import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from 'rxjs/Observable';
import { SERVER, LOGON_INFO, SCHEDULE } from "../app.constants";


@Injectable()
export class ScheduleService {

    login_user_id: string;
    login_comp_id: string;

    constructor(
        private _htc: HttpClient
    ) {
        this.login_user_id = LOGON_INFO.USER_ID;
        this.login_comp_id = LOGON_INFO.COMP_ID;
    }


    //スケジュール取得
    getScheduleList(start_ymd: string, end_ymd: string): Observable<Schedule[]> {
        return this._htc.get<Schedule[]>(SERVER.baseURL+'/schedule-list/'+this.login_comp_id+'/'+start_ymd+'/'+end_ymd+'/');
    }

    //運送スケジュール取得
    getCarTransScheduleList(start_ymd: string, end_ymd: string): Observable<Schedule[]> {
        return this._htc.get<Schedule[]>(SERVER.baseURL+'/cargo-schedule-list/'+this.login_comp_id+'/'+start_ymd+'/'+end_ymd+'/');
    }

    //スケジュール登録
    registSchedule(schedule: Schedule): Observable<Schedule> {
        return this._htc.post<Schedule>(SERVER.baseURL+'/regist-schedule/', JSON.stringify(this.setParam(schedule)));
        //return this._htc.post<Schedule>(SERVER.baseURL+'/regist-'+schedule.div+'-schedule/', JSON.stringify(this.setParam(schedule)));
    }

    //スケジュール更新
    updateSchedule(schedule: Schedule): Observable<Schedule> {
        return this._htc.put<Schedule>(SERVER.baseURL+'/update-schedule/'+schedule.id+'/', JSON.stringify(this.setParam(schedule)));
    }

    //スケジュール削除
    deleteSchedule(schedule: Schedule): Observable<Schedule> {
        return this._htc.delete<Schedule>(SERVER.baseURL+'/delete-schedule/'+schedule.id+'/');
    }


    setParam(schedule: Schedule) {
        schedule.div_id = schedule.div==SCHEDULE.CAR_SCHEDULE? schedule.car_id : schedule.driver_id;
        schedule.create_id = this.login_user_id;
        schedule.update_id = this.login_user_id;
        let etime = schedule.end_time + ":00:00";
        if (schedule.allday_flag) {
            schedule.start_time = "00";
            etime = "23:59:59";
        }
        schedule.start_date = schedule.start_date.formatted.split('/').join('-') + " " + schedule.start_time + ":00:00";
        schedule.end_date = schedule.end_date.formatted.split('/').join('-') + " " + etime;

        return schedule;
    }


}



export class Schedule {
    id: number;
    div: string;
    div_id: number;
    car_id: number;
    driver_id: number;
    allday_flag: boolean;
    start_date: any;
    end_date: any;
    start_time: string;
    end_time: string;
    button_start_date: Date;
    hourdiff: number;
    dayindex: number;
    title: string;
    etc: string;
    tooltip: string;
    create_id: string;
    create_date: Date;
    update_id: string;
    update_date: Date;
}



// WEBPACK FOOTER //
// ./src/app/schedule/schedule.service.ts